module.exports = __webpack_public_path__ + "static/media/je-suis-un-clitoris.60bfd04f.png";